// extracted by mini-css-extract-plugin
export default {"container":"OnboardingWelcome-module__container--5054","title":"OnboardingWelcome-module__title--cf8d","description":"OnboardingWelcome-module__description--8533"};